<template>
  <div class="pixelfie">
    <section>
      <v-img
        :src="require('../assets/img/bg_header_pixelfie.jpg')"
        width="100%"
        aspect-ratio="width"
        style=" padding: 100px 0px"
      >
        <v-row align="center" justify="center" style="margin: 10px">
          <v-col cols="12" sm="12" md="6" lg="6" class="text-center">
            <h1 class="display-3" style="margin: 10px">
              Pixelfile is an application that makes your favorite photos look
              like pixels easily!
            </h1>
            <v-btn
              light
              outlined
              style="margin: 10px;"
              href="https://apps.apple.com/jp/app/pixelfie/id1499263416"
            >
              Start Now for Free!
            </v-btn>
          </v-col>
          <v-col cols="12" sm="12" md="3" lg="3">
            <div class="device-wrapper" style="margin: 0 auto;">
              <div
                class="device"
                data-device="iPhone6"
                data-orientation="portrait"
                data-color="white"
                style="z-index: 10"
              >
                <div class="screen">
                  <v-img :src="require('../assets/img/cow.png')" />
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" sm="12" md="3" lg="3">
            <div class="device-wrapper" style="margin: 0 auto;">
              <div
                class="device"
                data-device="iPhone6"
                data-orientation="portrait"
                data-color="white"
                style="z-index: 10"
              >
                <div class="screen">
                  <v-img :src="require('../assets/img/cow-pixel.png')" />
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-img>
    </section>

    <section>
      <v-row
        align="center"
        justify="center"
        style="background: #8FFD84; padding: 50px"
      >
        <v-col cols="12" sm="12" md="4" lg="4">
          <v-img
            contain
            :src="require('../assets/img/Icon_pixelfie.png')"
            max-width="300px"
            max-height="300px"
            min-height="180px"
            min-width="180px"
            position="center"
            class="box"
          />
        </v-col>
        <v-col cols="12" sm="12" md="8" lg="8" class="text-center">
          <v-row justify="center">
            <h2 class="display-3" style="margin: 20px">
              Try it out with a variety of photos!
            </h2>
          </v-row>
          <v-row justify="center">
            <p class="display-1">
              Our app is available on iOS device! Download now to get started!
            </p>
          </v-row>
          <v-row justify="center">
            <v-col cols="12" sm="12" md="4" lg="4">
              <a
                class="badge-link"
                href="https://apps.apple.com/jp/app/pixelfie/id1499263416"
              >
                <v-img
                  contain
                  :src="require('../assets/img/app-store-badge.svg')"
                  height="60px"
                />
              </a>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </section>

    <section class="text-center">
      <v-row align="center" justify="center" style="background: #D3FED6;">
        <v-col cols="12">
          <v-card flat color="#D3FED6">
            <v-container fluid>
              <v-row>
                <v-col
                  v-for="n in 12"
                  :key="n"
                  class="d-flex child-flex"
                  cols="3"
                >
                  <v-card flat tile class="d-flex">
                    <v-img
                      :src="require(`../assets/img/samples/sample${n}.jpg`)"
                      aspect-ratio="1"
                      class="grey lighten-2"
                    />
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </section>

    <section>
      <v-img
        :src="require('../assets/img/bg-cta3.jpg')"
        width="100%"
        gradient="to top right, rgba(3,3,3,0.38), rgba(25,32,72,.7)"
        aspect-ratio="width"
      >
        <v-row style="height: 800px;" align="center" justify="center">
          <v-col cols="12" sm="12" md="5" lg="5" class="text-center">
            <v-row align="center" justify="center">
              <h1 class="display-3" style="margin: 20px; color: white;">
                Let's try it right away！
              </h1>
            </v-row>
            <v-row align="center" justify="center">
              <v-btn
                dark
                outlined
                style="margin: 10px;"
                href="https://apps.apple.com/jp/app/pixelfie/id1499263416"
              >
                Start Now for Free!
              </v-btn>
            </v-row>
          </v-col>
          <v-spacer />
        </v-row>
      </v-img>
    </section>

    <section>
      <v-row style="background: #D3FED6; padding: 50px 0px" align="center">
        <v-col cols="12">
          <v-row align="center" justify="center">
            <v-col cols="12" sm="12" md="12" lg="12" class="text-center">
              <h1 class="display-3">
                We <v-icon color="#db4a39" size="60">fas fa-heart</v-icon> new
                friends!
              </h1>
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <v-spacer></v-spacer>

            <v-col cols="2" sm="1" md="1" lg="1" class="text-center">
              <v-btn
                color="blue"
                fab
                icon
                x-large
                href="https://twitter.com/noby111"
              >
                <v-icon size="60">fab fa-twitter</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="2" sm="1" md="1" lg="1" class="text-center">
              <v-btn
                color="black"
                fab
                icon
                x-large
                href="https://github.com/nob3rise"
              >
                <v-icon size="60">fab fa-github</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="2" sm="1" md="1" lg="1" class="text-center">
              <v-btn
                color="orange darken-3"
                fab
                icon
                x-large
                href="https://www.nsunrise.work/p/index.html"
              >
                <v-icon size="60">fab fa-blogger</v-icon>
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
        </v-col>
      </v-row>
    </section>

    <footer>
      <v-row style="background: #55FED7;">
        <v-col class="text-center">
          <p style="color: #656565;">
            &copy; Nsunrise 2020. All Rights Reserved.
          </p>
        </v-col>
      </v-row>
    </footer>
  </div>
</template>

<script>
import "@/assets/css/portfolio.css";

export default {
  name: "Pixelfie",

  data: () => ({}),
};
</script>
